<template>
    <b-modal
        class="clean-modal organization-add-new-folder-modal"
        id="organization-assignment-show-create-folder-modal"
        :title="$t('organization.add_flyer')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="onOk"
        @show="onShow"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <b-form-input v-model="title"></b-form-input>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-organization-assignment-show-create-folder-component',
    props: {
        selectedFolder: Number,
        organizationFolderId: Number,
    },
    data() {
        return {
            title: '',
            hasError: false,
        };
    },
    methods: {
        onOk() {
            this.hasError = this.title === '';

            if (!this.hasError) {
                const data = {
                    name: this.title,
                    order: 0,
                };

                this.alert.saving(
                    this.$t('organization.add_exercise'),
                    this.$t('organization.exercise_will_be_saved_please_wait_a_moment'),
                );

                this.axios.post(this.routes.organizationAssignmentFolderCreate(this.organizationFolderId), data).then(
                    (response) => {
                        let folder = response.data;
                        folder.assignments = [];

                        this.$emit('add-folder', folder);
                        this.alert.success();
                    },
                    (error) => {
                        return this.alert.ajaxError(error);
                    },
                );
            }
        },
        onShow() {
            this.title = '';
        },
    },
};
</script>

<style scoped></style>
